import type { ReactNode } from "react"

import { cx } from "../lib/cx"
import styles from "./card.module.css"

/** Карточка — белая плоскость на кремовом фоне рабочей области. */
export function Card(props: {
  readonly children: ReactNode
  /** Отступы внутри. Снимаются, когда внутри таблица во всю ширину карточки. */
  readonly padded?: boolean
  readonly className?: string | undefined
}): ReactNode {
  return (
    <section className={cx(styles.card, props.padded === false ? undefined : styles.pad, props.className)}>
      {props.children}
    </section>
  )
}

/**
 * Шапка карточки с заголовком. Заголовок — настоящий h3, а не div с жирным шрифтом:
 * по заголовкам ходят клавишами программы чтения с экрана, и карточка без заголовка
 * в этом обходе просто отсутствует.
 */
export function CardHead(props: {
  readonly title: string
  readonly children?: ReactNode
  readonly className?: string | undefined
}): ReactNode {
  return (
    <header className={cx(styles.head, props.className)}>
      <h3 className={styles.title}>{props.title}</h3>
      {props.children === undefined ? null : (
        <>
          <span className={styles.spacer} />
          {props.children}
        </>
      )}
    </header>
  )
}
